function pushToDataLayer(items, data) {
  window.dataLayer = window.dataLayer || [];
  const products = items.map((item, index) => ({
    name: item.product_title,
    id: item.sku,
    price: item.price / 100,
    brand: item.vendor,
    category: item.product_type,
    quantity: item.quantity,
    dimension1: item.variant_title,
    dimension2: item.variant_id,
    dimension3: data[index].scent || "",
    dimension4: data[index].key_ingredient || "",
    dimension5: data[index].skin_type || "",
    dimension6: data[index].hair_type || ""
  }));

  window.dataLayer.push({
    event: 'ProductAddToCart',
    ecommerce: {
      currencyCode: Shopify.currency.active,
      add: {
        products
      }
    }
  });
  console.log('%cEvent: ProductAddToCart', 'color: #FF9100');
  console.log(window.dataLayer);
}

document.addEventListener('addToCart', async (event) => {
  try {
    let items = [];
    if (!event.detail.data.items) {
      items.push(event.detail.data);
    } else {
      items = event.detail.data.items;
    }

    const data = await Promise.all(items.map(async (item) => {
      const resp = await fetch(`${Shopify.routes.root}products/${item.handle}?view=json`);
      return resp.json();
    }));

    pushToDataLayer(items, data);
  } catch(err) {
    console.error(err);
  }
});
